// extracted by mini-css-extract-plugin
module.exports = {"FormCardComponent":"FormCard_FormCardComponent__2pqwL"};